import './utils/bigNumberConfig';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Wrapper from './components/wrapper';
import './shim';
import getConfig, { APP_META } from './services/config';
import db from './store/RefDatabase';
import { purgeLegacyKeyStorage } from './services/walletKeys';

document.title = APP_META.name;
purgeLegacyKeyStorage();

// ReactDOM.render(
//   <Wrapper>
//     <App />
//   </Wrapper>,
//   document.querySelector('#root')
// );

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
// Clear cached pools/prices from another exchange before anything reads them.
db.resetIfExchangeChanged(getConfig().REF_FI_CONTRACT_ID)
  .catch(() => {})
  .finally(() =>
    root.render(
      <Wrapper>
        <App />
      </Wrapper>
    )
  );

const myWorker = new Worker(
  new URL(
    /* webpackChunkName: "worker" */ 'cacheRefreshWorker.ts',
    import.meta.url
  ),
  { type: 'module' }
);

function sendWorkerData() {
  const config = getConfig();
  myWorker.postMessage({
    config,
  });
}

sendWorkerData();
